import { useContext } from 'react';
import { LanguageContext } from '../LanguageContext';

function LanguageSwitcher() {
  const { language, changeLanguage } = useContext(LanguageContext);
  const isArabic = language === 'ar';

  const toggleLanguage = () => {
    const newLang = isArabic ? 'en' : 'ar';
    changeLanguage(newLang);
  };

  return (
    <div style={{marginTop:'5px'}}>
      <div className="switch">
        <input
          id="language-toggle"
          className="check-toggle check-toggle-round-flat"
          type="checkbox"
          checked={isArabic}
          onChange={toggleLanguage}
       
        />
        <label htmlFor="language-toggle" style={{backgroundColor:'#f5f5f5',  boxShadow:'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px'}}></label>
        <span className="on" style={{color:'#000',lineHeight:'65%' ,fontFamily:'Oswald', fontWeight:'300' }}>EN</span>
        <span className="off" style={{color:'#000',lineHeight:'65%', fontFamily:'Oswald', fontWeight:'300'}}>AR</span>
      </div>
    </div>
  );
}

export default LanguageSwitcher;
